import { apiSlice } from "./ApiSlice";

const AddpatientApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Addpatient: builder.mutation({
      query: (credentials) => {
     
        return {
          url: "/api/ClinicProfile/PatientDetails",
          method: "POST",
          body: JSON.stringify(credentials),
          headers: {
            'Content-Type': 'application/json',
          },
        }; 
      },
      invalidatesTags: ['patients']
    }),

    Getallpatients: builder.query({
      query: (clinicUserId) => ({
        url: `/api/ClinicProfile/GetPatientListView?userclinicid=${clinicUserId}`,
        method: "GET",
      }),
      providesTags: ["patients"],
    }),

    PostFilteredPatients: builder.mutation({
      query: (data) => ({
        url: `/api/ClinicProfile/PatientsTableFilter`,
        method: "POST",
        body: data,
      }),
    }),

    Getpatient: builder.query({
      query: (patientId) => {
    
        return {
          url: `/api/ClinicProfile/GetPatientDetails?useruniqueid=${patientId}`,
          method: "GET"
        };
      },
      providesTags: ["patients"],
    }),

    Getpatientoverview: builder.query({
      query: (patientUserUniqueID) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Appointments-History?patientUserUniqueID=${patientUserUniqueID}`,
          method: "GET"
        };
      },
      providesTags: ["patients"],
    }),

    Getpatientdoctoroverview: builder.query({
      query: ({patientUserUniqueID,DoctorUserUniqueID}) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Appointments-History?patientUserUniqueID=${patientUserUniqueID}&DoctorUserUniqueID=${DoctorUserUniqueID}`,
          method: "GET"
        };
      },
      providesTags: ["patients"],
    }),

     Getpatientoverviewcards: builder.query({
      query: ({patientUserUniqueID,clinicUserId}) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Tabs?userClinicID=${clinicUserId}&patientUserUniqueID=${patientUserUniqueID}`,
          method: "GET"
        };
      },
      providesTags: ["patients"],
    }),

    Getpatientdoctoroverviewcards: builder.query({
      query: ({patientUserUniqueID,DoctorUserUniqueID,clinicUserId}) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Tabs?userClinicID=${clinicUserId}&patientUserUniqueID=${patientUserUniqueID}&DoctorUserUniqueID=${DoctorUserUniqueID}`,
          method: "GET"
        };
      },
      providesTags: ["patients"],
    }),

    checkMobileNumber: builder.query({
      query: ({ mobileverifications, userClinicId }) => ({
        url: `/api/ClinicProfile/checkmobilenumber?Mobileverifications=${mobileverifications}&UserClinicID=${userClinicId}`,
        method: "GET",
      }),
    }),


  }),
});

export const { useAddpatientMutation,useLazyGetallpatientsQuery, usePostFilteredPatientsMutation,useLazyGetpatientQuery,useLazyGetpatientoverviewQuery,useLazyGetpatientdoctoroverviewQuery,useLazyGetpatientoverviewcardsQuery,useLazyGetpatientdoctoroverviewcardsQuery,useLazyCheckMobileNumberQuery } = AddpatientApiSlice;
